import React from 'react'
import { Popover, FormControl, Select, MenuItem, Button, Grid, InputLabel } from '@mui/material'
import { formObjChangeObj } from "../../../../reducers/form";
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
const arr = [
  { label: 'Позиция', value: 'number' },
  { label: 'Наименование*', value: 'name' },
  { label: 'Тип, марка, обозначение документа, опросного листа', value: 'typeMark' },
  { label: 'Артикул, Код оборудования, изделия, материала', value: 'vendorCode' },
  { label: 'Завод-изготовитель:', value: 'manufacturer' },
  { label: 'Ед. изм.*', value: 'storageUnit' },
  { label: 'Количество*', value: 'count' },
  { label: 'Масса единицы, кг', value: 'unitWeightKg' },
  { label: 'Стоимость единицы', value: 'price' },
  { label: 'Тэги', value: 'tags' },
  { label: 'Примечание', value: 'note' },
]
export default function PopperColumnType({ anchorEl, selectKey, onClose, column, formName }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const handleSelectChange = (e) => {
    let selected = { label: '' }
    if (e.target.value !== '') {
      selected = arr.find((l) => l.value === e.target.value)
    }
    dispatch(formObjChangeObj({ select: e.target.value, selectName: selected.label }, { field: 'column', id: selectKey, name: formName }))
    onClose()
  }
  const handleHideColumn = () => {
    dispatch(formObjChangeObj({ visible: false }, { field: 'column', id: selectKey, name: formName }))
    onClose()
  }
  const allowedSelects = new Set(
    Object.values(column)
      .map(item => item.select)
      .filter(val => val !== '' && val != null) // <-- Ключевое изменение
  );
  return <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    onClose={onClose}
  >
    <div className='App-paper'>
      <Grid container
        direction="column"
        justifyContent="center"
        alignItems="stretch"
      >
        <Grid item><Button color='primary' onClick={handleHideColumn}>Скрыть столбец</Button></Grid>
        <Grid item>
          <FormControl className={classes.formControl}>
            <InputLabel>Тип колонки</InputLabel>
            <Select
              variant="standard"
              value={(selectKey) ? column[selectKey].select : ''}
              onChange={handleSelectChange}
            >
              <MenuItem value=""><em>None</em></MenuItem>
              {arr.map(e => <MenuItem key={e.value} value={e.value} disabled={allowedSelects.has(e.value)&&column[selectKey]?.select!==e.value}>{e.label}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  </Popover>
}